import { render, staticRenderFns } from "./HtmlRendering.vue?vue&type=template&id=48df788b&scoped=true&"
import script from "./HtmlRendering.vue?vue&type=script&lang=js&"
export * from "./HtmlRendering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48df788b",
  null
  
)

export default component.exports